import BaseEntity from '@/entities/BaseEntity';

export default class PostAiMeta extends BaseEntity {
  title = '';
  value = null;
  details = '';
  details_translation = '';

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
